<template>
  <GuDropdownMenu>
    <GuDropdownMenuTrigger hide-arrow as-child>
      <GuButton
        :id="`ag-grid-cell-renderer-contact-actions-${params.data['id']}`"
        variant="link"
        class="w-100"
        :aria-label="`View actions for contact ID ${params.data['id']}`"
      >
        ...
      </GuButton>
    </GuDropdownMenuTrigger>
    <GuDropdownMenuContent :collision-padding="{ right: 37 }">
      <GuDropdownMenuItem
        :disabled="isActionDisabled"
        @select="editContact"
      >
        Edit
      </GuDropdownMenuItem>
      <GuDropdownMenuItem
        :disabled="isActionDisabled"
        @select="copyContact"
      >
        Copy
      </GuDropdownMenuItem>
      <GuDropdownMenuItem
        :disabled="isActionDisabled"
        @select="deleteContact"
      >
        <span :class="['text-danger', isActionDisabled && 'opacity-50']">
          Delete
        </span>
      </GuDropdownMenuItem>
    </GuDropdownMenuContent>
  </GuDropdownMenu>
</template>

<script setup>
import { inject, toRefs, computed } from 'vue'
import { GuButton } from '@shared/gu-components/button'
import {
  GuDropdownMenu,
  GuDropdownMenuContent,
  GuDropdownMenuItem,
  GuDropdownMenuTrigger,
} from '@shared/gu-components/dropdown-menu'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const { params } = toRefs(props)

const {
  setFormDialogEditMode,
  setIsOpenCloneDialog,
  setIsOpenDeleteDialog,
} = inject('contacts')

const selectedContact = computed(() => {
  return params.value.data
})

const isCompanyAdmin = computed(() => {
  return params.value.isCompanyAdmin
})

const isCompanyContact = computed(() => {
  return selectedContact.value.isCompany
})

const isActionDisabled = computed(() => {
  return isCompanyContact.value && !isCompanyAdmin.value
})

const isSelf = computed(() => {
  return selectedContact.value.id === -1
})

const editContact = () => {
  if (isSelf.value) {
    window.location.href = '/Useraction/1/Update%20My%20Account/Start'
    return
  }
  setFormDialogEditMode()
}

const copyContact = () => {
  setIsOpenCloneDialog(true)
}

const deleteContact = () => {
  setIsOpenDeleteDialog(true)
}
</script>
